<template>
  <div>
    <Header />
    <Home />
    <Portfolio />
    <Toucan />
    <About />
    <!-- <Service /> -->
    <Experience />
    <Contact />
    <Footer />
    <div class="loader-container">
      <img src="../src/assets/images/loader-img.gif" alt="" />
    </div>
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Home from "./components/Home.vue";
import About from "./components/About.vue";
import Toucan from "./components/Toucan.vue";
// import Service from "./components/Service.vue";
import Experience from "./components/Experience.vue";
import Portfolio from "./components/Portfolio.vue";
import Contact from "./components/Contact.vue";
import Footer from "./components/Footer.vue";

export default {
  components: {
    Header,
    Home,
    About,
    // Service,
    Toucan,
    Experience,
    Portfolio,
    Contact,
    Footer,
  },
  mounted() {
    console.log("mounted");
    // console.log(this.$el.textContent);
    // I'm text inside the component.
    this.fadeOut();
  },
  methods: {
    loader() {
      document.querySelector(".loader-container").classList.add("active");
    },
    fadeOut() {
      setTimeout(this.loader, 5000);
    },
  },
};
</script>

<style></style>
